import { IDrive } from '../DriveBase/types';

export interface IDriveOneSpeed extends IDrive {

}

export const schema = 'AutomationApps.Devices.Drives.DriveOneSpeed';
export const schemaFan = 'AutomationApps.Devices.Drives.FanOneSpeed';
export const schemaOutput = 'AutomationApps.Devices.Drives.OutputOneSpeed';
export const schemaPump = 'AutomationApps.Devices.Drives.PumpOneSpeed';
export const schemaPump1 = 'AutomationApps.Devices.Drives.Pump1OneSpeed';
export const schemaPump2 = 'AutomationApps.Devices.Drives.Pump2OneSpeed';